import { render } from "./ComponentCombo.vue?vue&type=template&id=652ba60c"
import script from "./ComponentCombo.vue?vue&type=script&lang=js"
export * from "./ComponentCombo.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__